import ChatbotContainer from './ChatbotContainer';

export default ChatbotContainer;
